import React from 'react';
import {getModal} from '@/utils/CommonModal';

export const getCustomModal = (type, deps) => {
  const {
    isCancel,
    isNameValid,
    handleValidationModalClose,
    onClickPrimaryButton,
    onClickSecondaryButton,
    handleCancel
  } = deps;

  switch (type) {
    case 'CANCEL_MODAL':
      return getModal({
        title: 'Are you sure you want to cancel?',
        text: 'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO',
        showPrimaryButton: true,
        primaryButtonText: 'Yes',
        onClickPrimaryButton,
        showSecondaryButton: true,
        secondaryButtonText: 'No',
        onClickSecondaryButton,
        showModal: isCancel,
        onCloseModal: handleCancel,
        hideCloseButton: false
      });
    case 'NAME_VALIDATION_MODAL':
      return getModal({
        title: 'Duplicate Name Detected',
        text: (
          <>
            It looks like there's already an Activity with this name.
            <br />
            To avoid confusion, please enter a unique name before continuing.
          </>
        ),
        showPrimaryButton: true,
        primaryButtonText: 'Edit Name',
        onClickPrimaryButton: handleValidationModalClose,
        showSecondaryButton: false,
        showModal: !isNameValid,
        onCloseModal: handleValidationModalClose,
        hideCloseButton: true
      });
    default:
      return null;
  }
};
